import React from "react";
import {
    Card,
    CardHeader,
    CardContent,
    Fade,
    Table,
    TableRow,
    TableCell,
    TableHead,
    TableBody
} from "@material-ui/core";
class ExamplePage extends React.Component {
    render() {
        return (
            <div>
                <Fade in={true} timeout={{ enter: 400, exit: 400 }}>
                    <Card>
                        <CardHeader title={`Example Page`} subheader={`Example Page`} />

                        <CardContent>
                            <Table fixedheader={"false"} style={{ tableLayout: "auto" }}>
                                <colgroup>
                                    <col width="150px" />
                                    <col width="140px" />
                                    <col width="240px" />
                                </colgroup>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Company Name</TableCell>
                                        <TableCell>Amounts</TableCell>
                                        <TableCell>Amounts</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell> name 1 </TableCell>
                                        <TableCell> $100 </TableCell>
                                        <TableCell> $100 </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Fade>
            </div>
        );
    }
}

export default ExamplePage;
